/**
 * Safely formats a date string or Date object.
 * Returns an empty string if the date is invalid or missing.
 */
export const formatDate = (
  dateInput,
  options = { month: 'short', year: 'numeric' },
  locale = 'en-US'
) => {
  if (!dateInput) return '';

  const date = new Date(dateInput);

  // Check if date is valid using getTime()
  if (isNaN(date.getTime())) return '';

  return date.toLocaleDateString(locale, options);
};